import { api } from './_client';
import type {
  InventoryLocation,
  InventoryLocationCreate,
  InventoryLocationUpdate,
  InventoryItem,
  InventoryItemCreate,
  InventoryItemUpdate,
} from '../../types/api';

export const inventoryApi = {
  async getInventoryLocations(): Promise<InventoryLocation[]> {
    const response = await api.get<InventoryLocation[]>('/inventory/locations');
    return response.data;
  },

  async createInventoryLocation(data: InventoryLocationCreate): Promise<InventoryLocation> {
    const response = await api.post<InventoryLocation>('/inventory/locations', data);
    return response.data;
  },

  async updateInventoryLocation(
    locationId: string,
    data: InventoryLocationUpdate
  ): Promise<InventoryLocation> {
    const response = await api.put<InventoryLocation>(
      `/inventory/locations/${encodeURIComponent(locationId)}`,
      data
    );
    return response.data;
  },

  async deleteInventoryLocation(locationId: string): Promise<void> {
    await api.delete(`/inventory/locations/${encodeURIComponent(locationId)}`);
  },

  async getInventoryItems(params?: {
    location_id?: string;
    category?: string;
    search?: string;
  }): Promise<InventoryItem[]> {
    const response = await api.get<InventoryItem[]>('/inventory/items', { params });
    return response.data;
  },

  async createInventoryItem(data: InventoryItemCreate): Promise<InventoryItem> {
    const response = await api.post<InventoryItem>('/inventory/items', data);
    return response.data;
  },

  async updateInventoryItem(itemId: string, data: InventoryItemUpdate): Promise<InventoryItem> {
    const response = await api.put<InventoryItem>(
      `/inventory/items/${encodeURIComponent(itemId)}`,
      data
    );
    return response.data;
  },

  async deleteInventoryItem(itemId: string): Promise<void> {
    await api.delete(`/inventory/items/${encodeURIComponent(itemId)}`);
  },
};
